const getters = {
  // user
  openId: state => state.user.openId,
  userInfo: state => state.user.userInfo,
  loginStatus: state => state.user.loginStatus
}
export default getters
